export default "__VITE_ASSET__DHXoyyCH__"